<template>
  <div class="category-container">
    <div class="mb-4">
      <div class="mb-2"><strong>MASTER PRODUCT</strong></div>
      <button
        type="button"
        :class="['product-name-box', { active: selectedProduct && selectedProduct.id == product.id }]"
        @click="$emit('select', product)"
      >
        {{ getDisplayName(product) }}
      </button>
    </div>
    <div>
      <div class="mb-2"><strong>VARIATIONS</strong></div>
      <div>
        <button
          type="button"
          :class="['product-name-box mb-2', { active: selectedProduct && selectedProduct.id == variant.id }]"
          v-for="variant of variants"
          :key="variant.id"
          @click="$emit('select', variant)"
        >
          {{ getDisplayName(variant) }}
        </button>
      </div>
      <div v-if="!variants.length">No Variants.</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    variants: {
      type: Array,
      default: () => [],
    },
    selectedProduct: {
      type: Object,
      default: null,
    },
    getDisplayName: {
      type: Function,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.category-container {
  position: sticky;
  top: $sectionGap;
  padding-right: 5px;
}

.product-name-box {
  width: 100%;
  text-align: left;
  padding: 10px;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  color: inherit;

  &:hover,
  &.active {
    border-color: $primaryColor;
    color: $primaryColor;
    font-weight: bold;
  }
}
</style>
